import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import dictionary from 'config/dictionary';
import styles from './card.module.scss';
import {
  ButtonArrowState,
  Button as TitleTypography,
  TertiaryButton
} from '@huggg/react-components';
import { interpolate } from 'utilities/interpolate';

const CardContent = ({
  brandAssets,
  brandName,
  voucherAmount,
  formattedVoucherExpiry,
  processedVoucherLabel,
  isWaitingForFulfil,
  onClaimCard
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '35px',
        marginTop: '35px'
      }}
    >
      <TitleTypography className={classnames(styles.title)}>
        Your {brandName} gift card is ready!
      </TitleTypography>

      <img
        src={brandAssets.giftCardUrl}
        alt={'gift-card'}
        style={{
          height: 'auto',
          width: '100%',
          maxWidth: '330px',
          borderRadius: '10px'
        }}
      />

      <TitleTypography className={classnames(styles.title)}>
        Gift card value:{' '}
        <span style={{ fontWeight: 'bold' }}>{voucherAmount}</span>
      </TitleTypography>

      {formattedVoucherExpiry && (
        <p className={styles.voucherExpiry}>
          {interpolate(
            dictionary.voucherExpiry,
            '[expiry_date]',
            <>{formattedVoucherExpiry}</>
          )}
        </p>
      )}

      <TitleTypography
        className={classnames(styles.title)}
        style={{ fontWeight: 500 }}
      >
        Ready to make a purchase?
      </TitleTypography>

      <TertiaryButton
        loading={isWaitingForFulfil}
        className={styles.voucherButton}
        onClick={onClaimCard}
        data-test-id="button-visit-external"
        label={processedVoucherLabel}
        arrow={ButtonArrowState.None}
      />
    </div>
  );
};

CardContent.propTypes = {
  brandAssets: PropTypes.object.isRequired,
  brandName: PropTypes.string,
  voucherAmount: PropTypes.string,
  formattedVoucherExpiry: PropTypes.string,
  processedVoucherLabel: PropTypes.string,
  isWaitingForFulfil: PropTypes.bool.isRequired,
  onClaimCard: PropTypes.func.isRequired
};

export default CardContent;
